import { flattenDeep, findIndex, find, groupBy } from 'lodash';

import { getDurationString } from '../../../utils';
import * as constants from './PureModeBook.constants';
import * as services from './PureModeBook.service';

const state = {
  Book: null,
  _Book: null,
  BasisVideos: [],
  ReadyToPlayVideos: [],
  isRequest: false,
};

const mutations = {
  [constants.SET_BULLET_STATUS](state, { video, status }) {
    const idx = findIndex(state.ReadyToPlayVideos, (v) => v.videoId == video.videoId);
    state.ReadyToPlayVideos[idx].bulletStatus = status;
    const list = state.Book.readingGroupList;
    for (let i = 0, l = list.length; i < l; i++) {
      const videos = list[i].videos;
      for (let ii = 0, ll = videos.length; ii < ll; ii++) {
        const v = videos[ii];
        if (v.bulletId == video.bulletId && v.videoId == video.videoId) {
          v.bulletStatus = status;
        }
      }
    }
  },

  [constants.FILE_GENERATED_SUCCESS](state, { fileId, filePath }) {
    for (let i = 0, l = state.Book.files.length; i < l; i++) {
      const file = state.Book.files[i];
      if (file.fileId == fileId) {
        file.filePath = filePath;
      }
    }
  },

  [constants.GET_PURE_BOOK_SUCCESS](state, Book) {
    state.Book = Book;
    const bookObj = { ...Book };
    const readings = bookObj.readingGroupList.map((v) => {
      return {
        ...v,
        t1: (() => {
          let arr = [];
          let obj = groupBy(v.videos, 'subjectOrder');
          for (let key in obj) {
            arr.push({
              subjectId: obj[key][0].subjectId,
              subjectName: obj[key][0].subjectName,
              canAccess: !(obj[key] && obj[key].filter((v) => v.canAccess).length),
              bullets: obj[key],
            });
          }
          return arr;
        })().length,
        t2: v.videos.length,
        t3: (function () {
          let sum = 0;
          for (let i = 0, l = v.videos.length; i < l; i++) {
            sum += v.videos[i].duration;
          }
          return getDurationString(sum);
        })(),
        subjects: (() => {
          let arr = [];
          let obj = groupBy(v.videos, 'subjectOrder');
          for (let key in obj) {
            arr.push({
              subjectId: obj[key][0].subjectId,
              subjectName: obj[key][0].subjectName,
              canAccess: !(obj[key] && obj[key].filter((v) => v.canAccess).length),
              bullets: obj[key],
            });
          }
          return arr;
        })(),
      };
    });
    state._Book = readings;
    state.ReadyToPlayVideos = flattenDeep(
      state.Book.readingGroupList
        .map((v) => v.videos)
        .map((v) => {
          if (v.length == 0) {
            return v;
          }
          const last = v.pop();
          last['endOfReading'] = true;
          v.push(last);
          return v;
        })
    ).map((v, i, arr) => {
      return {
        courseId: Book.courseId,
        bookId: Book.bookId,
        bulletName: v.bulletName,
        bulletId: v.bulletId,
        videoId: v.videoId,
        speed1: v.vpath,
        speed1Dot3: v.vpath_1_3,
        speed1Dot5: v.vpath_1_5,
        speed2: v.vpath_2,
        vpathFree: v.vpathFree,
        freeMode: Book.freeMode,
        isLatest: i === arr.length - 1,
        endOfReading: v.endOfReading ? true : false,
        collected: v.collected ? true : false,
        bulletStatus: v.bulletStatus,
        isNew: v.newPath ? true : false,
        lastProgress: v.lastProgress,
        videoSpeed: v.videoSpeed,
        canAccess: v.canAccess,
      };
    });
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.ADD_VIDEO_TO_FAVORITE_LIST](state, bulletId) {
    const index = findIndex(state.ReadyToPlayVideos, (v) => v.bulletId === bulletId);
    if (index != -1) {
      const elem = state.ReadyToPlayVideos[index];
      elem.collected = !elem.collected;
    }
  },
};

const actions = {
  async getBook({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getBook(payload);
    commit(constants.GET_PURE_BOOK_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async addToFavoriteList({ commit }, payload) {
    const res = await services.addToFavoriteList(payload);
    if (res.data.data) {
      commit(constants.ADD_VIDEO_TO_FAVORITE_LIST, payload.bulletId);
    }
  },

  async generateFile({ commit }, payload) {
    const res = await services.generateFile(payload);
    commit(constants.FILE_GENERATED_SUCCESS, { ...payload, filePath: res.data.data });
  },
};

const getters = {
  isLockedByStudentWorkStatus: (state) => {
    return state.Book.studentWorkEntity && 0 === state.Book.studentWorkEntity.studentWorkStatus;
  },

  _Book: (state) => state._Book,

  Book: (state, getters) => {
    if (!state.Book) {
      return state.Book;
    } else {
      const isLockedByStudentWorkStatus = getters.isLockedByStudentWorkStatus;
      return {
        ...state.Book,
        c_isLockedByStudentWorkStatus: isLockedByStudentWorkStatus,
        c_isCanStudy: state.Book.canAccess && !isLockedByStudentWorkStatus,
      };
    }
  },

  isRequest: (state) => state.isRequest,
  ReadyToPlayVideos: (state) => state.ReadyToPlayVideos.filter((v) => v.canAccess),

  lastTimeReadingBulletId: (state) => {
    const lastTimeReading = find(state.Book.readingGroupList, (reading) => reading.isCurrent);
    if (lastTimeReading) {
      const lastTimeBullet = find(lastTimeReading.videos, (bullet) => bullet.isCurrent);
      if (lastTimeBullet) {
        return {
          readingId: lastTimeReading.readingId,
          bulletId: lastTimeBullet.bulletId,
        };
      }
    }
    return {
      readingId: -1,
      bulletId: -1,
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
